import React from 'react';
import {
    Sidebar,
    Menu,
    MenuItem,

} from 'react-pro-sidebar';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../images/logo.png';
import LogoSm from '../images/fav-icon.png';
import iconDashboard from '../images/icon_sidebar-dashboard.png';
import iconUser from '../images/icon_sidebar-user.png';
import iconPromocode from '../images/icon_sidebar-promocode.png';
import iconSubscription from '../images/icon_sidebar-subscription.png';
import iconPayments from '../images/icon_sidebar-payments.png';
import './index.scss';



const SidebarMain = ({ sidebarState, toggleSidebar, sidebarRef, closeSidebarOnLinkClick }) => {

    const location = useLocation();

    const menuItem = [
        {
            path: "/dashboard",
            name: "Dashboard",
            icon: <img src={iconDashboard} alt="Dashboard" />

        },
        {
            path: "/user-management",
            name: "User Management",
            icon: <img src={iconUser} alt="User" />

        },
        // {
        //     path: "/promocode-management",
        //     name: "Promocode Management",
        //     icon: <img src={iconPromocode} alt="Promocode" />

        // },
        {
            path: "/subscription-plan-management",
            name: "Subscription Plan Management",
            icon: <img src={iconSubscription} alt="Subscription" />

        },
        {
            path: "/payments-information",
            name: "Payments Information",
            icon: <img src={iconPayments} alt="Payments" />

        },

    ];



    const handleLinkClick = () => {
        if (sidebarState === 0) {
            closeSidebarOnLinkClick();

        }

    };



    return (

        <Sidebar
            toggled={sidebarState === 0}
            collapsed={sidebarState === 1}
            hidden={sidebarState === 2}
            onBackdropClick={toggleSidebar}
            breakPoint="md"
            className="custom-styles"
            ref={sidebarRef}
            // transitionDuration={200}

            rootStyles={{
                position: "sticky",
                top: 0,
                height: "100vh",
            }}
        >

            <div className="custom-header">
                <div className="logotext">
                    {sidebarState !== 1 ? (
                        <img src={sidebarState === 0 ? Logo : Logo} alt="Logo" className='image-fluid w-100 py-2 px-3' />
                    ) : (
                        <img src={LogoSm} alt='Logo' className='image-fluid w-100 py-3 bg-white' />
                    )}
                </div>



                <div className="position-relative pt-2">
                    <div
                        className="closemenu position-absolute"
                        style={{ zIndex: "999", right: 0, top: -20 }}
                        onClick={toggleSidebar}
                    >
                        {sidebarState === 0 ? <FaArrowLeft /> : <FaArrowRight />}
                    </div>
                </div>

            </div>

            <Menu iconShape="circle">
                {/* {menuItem.map((item, index) => (
                    <MenuItem key={index} className={location.pathname.startsWith(item.path) ? 'active' : ''}
                    >
                        <NavLink
                            to={item.path}
                            className="link d-flex text-decoration-none gilroy-semibold"
                            onClick={handleLinkClick}
                        >
                            <div className={`icon ${sidebarState === 1 ? 'collapsed' : ''}`}>
                                {item.icon}
                            </div>
                            <div className={`link_text mx-2 ${sidebarState === 1 ? 'collapsed-text' : ''}`}>
                                {item.name}
                            </div>
                        </NavLink>
                    </MenuItem>
                ))} */}

                {menuItem.map((item, index) => {
                    const isActive = location.pathname.startsWith(item.path);
                    return (
                        <MenuItem 
                            key={index} 
                            className={isActive ? 'active' : ''}
                            component={<NavLink to={item.path} />}
                            onClick={handleLinkClick}
                        >
                            {sidebarState === 1 ? (
                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        <Tooltip>
                                            {item.name}
                                        </Tooltip>
                                    }
                                >
                                    <div className="link d-flex text-decoration-none gilroy-semibold">
                                        <div className={`icon ${sidebarState === 1 ? 'collapsed' : ''}`}>
                                            {item.icon}
                                        </div>
                                        <div className={`link_text mx-2 ${sidebarState === 1 ? 'collapsed-text' : ''}`}>
                                            {item.name}
                                        </div>
                                    </div>
                                </OverlayTrigger>
                            ) : (
                                <div className="link d-flex text-decoration-none gilroy-semibold">
                                    <div className={`icon ${sidebarState === 1 ? 'collapsed' : ''}`}>
                                        {item.icon}
                                    </div>
                                    <div className={`link_text mx-2 ${sidebarState === 1 ? 'collapsed-text' : ''}`}>
                                        {item.name}
                                    </div>
                                </div>
                            )}
                        </MenuItem>
                    );
                })}

            </Menu>
        </Sidebar>
    );

};



export default SidebarMain;

